module.exports = __webpack_public_path__ + "img/1_ku.ff17e023.jpg";